import React from 'react';
import './simple-modal.scss';

interface SimpleModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSubmit?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
}

export const SimpleModal: React.FC<SimpleModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  submitLabel = 'Submit',
  cancelLabel = 'Cancel',
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <div className="simple-modal-overlay" onClick={handleOverlayClick}>
      <div className="simple-modal">
        <div className="simple-modal__header">
          <h2 className="simple-modal__title">{title}</h2>
          <button
            className="simple-modal__close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="simple-modal__form">
          <div className="simple-modal__content">
            {children}
          </div>
          
          <div className="simple-modal__footer">
            <button
              type="button"
              onClick={onClose}
              className="simple-modal__btn simple-modal__btn--cancel"
            >
              {cancelLabel}
            </button>
            {onSubmit && (
              <button
                type="submit"
                className="simple-modal__btn simple-modal__btn--submit"
              >
                {submitLabel}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
